/**
 * Frontend Logger Utility
 * Respects VITE_LOG_LEVEL environment variable
 */

enum LogLevel {
  DEBUG = 0,
  INFO = 1,
  WARN = 2,
  ERROR = 3,
  NONE = 4,
}

class FrontendLogger {
  private static instance: FrontendLogger;
  private logLevel: LogLevel;

  private constructor() {
    const configuredLevel = import.meta.env.VITE_LOG_LEVEL?.toLowerCase() || 'debug';

    const levelMap: { [key: string]: LogLevel } = {
      'debug': LogLevel.DEBUG,
      'info': LogLevel.INFO,
      'warn': LogLevel.WARN,
      'error': LogLevel.ERROR,
      'none': LogLevel.NONE,
    };

    this.logLevel = levelMap[configuredLevel] ?? LogLevel.DEBUG;
  }

  static getInstance(): FrontendLogger {
    if (!FrontendLogger.instance) {
      FrontendLogger.instance = new FrontendLogger();
    }
    return FrontendLogger.instance;
  }

  debug(...args: any[]): void {
    if (this.logLevel <= LogLevel.DEBUG) {
      console.log('[DEBUG]', ...args);
    }
  }

  info(...args: any[]): void {
    if (this.logLevel <= LogLevel.INFO) {
      console.info('[INFO]', ...args);
    }
  }

  warn(...args: any[]): void {
    if (this.logLevel <= LogLevel.WARN) {
      console.warn('[WARN]', ...args);
    }
  }

  error(...args: any[]): void {
    if (this.logLevel <= LogLevel.ERROR) {
      console.error('[ERROR]', ...args);
    }
  }
}

// Export singleton instance and convenience methods
const logger = FrontendLogger.getInstance();

export const debugLog = (...args: any[]) => logger.debug(...args);
export const infoLog = (...args: any[]) => logger.info(...args);
export const warnLog = (...args: any[]) => logger.warn(...args);
export const errorLog = (...args: any[]) => logger.error(...args);

export default logger;
